import React from 'react';

interface AttorneyIconProps {
  height?: number;
  width?: number;
  color?: string;
}

const AttorneyIcon: React.FC<AttorneyIconProps> = ({ height, width, color = '#FFE4E1' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 500 500"
      width={`${width}pt`}
      height={`${height}pt`}
    >
      <path
        style={{ fill: color }}
        d="M132.52,192.2a71,71,0,1,1,71-71A71.08,71.08,0,0,1,132.52,192.2Zm0-130.64a59.63,59.63,0,1,0,59.63,59.63A59.7,59.7,0,0,0,132.52,61.56Z"
      />
      <path
        style={{ fill: color }}
        d="M157.08,145a20.93,20.93,0,0,1-7.3,7.51,25.55,25.55,0,0,1-11.41,3.65v8.21h-6.59v-8.21q-9.52-.92-15.41-6a16.79,16.79,0,0,1-5.88-13.38h12.37a11,11,0,0,0,2.54,6.54,10.44,10.44,0,0,0,6.38,3.3V124.28a80.89,80.89,0,0,1-11-3.5,17.69,17.69,0,0,1-7.25-5.62q-3-3.85-3-10.55a18.32,18.32,0,0,1,5.88-13.94q5.88-5.52,15.41-6.44V76h6.59v8.21q8.92.81,14.35,5.63t6.13,13.23H146.48a10,10,0,0,0-2.43-5.63,10.82,10.82,0,0,0-5.68-3.39V116a74.81,74.81,0,0,1,11.06,3.39,17.64,17.64,0,0,1,7.19,5.58q2.94,3.8,2.94,10.49A19.33,19.33,0,0,1,157.08,145Zm-32.34-34.47a17.76,17.76,0,0,0,7,3.75V93.76a11.18,11.18,0,0,0-6.94,3.15,9.65,9.65,0,0,0-2.59,7.09A8.44,8.44,0,0,0,124.74,110.49ZM145.37,143a10.18,10.18,0,0,0,2.53-7,8.15,8.15,0,0,0-2.48-6.33,18.38,18.38,0,0,0-7-3.71v20.59A11.37,11.37,0,0,0,145.37,143Z"
      />
      <path
        style={{ fill: color }}
        d="M327.64,449.83H75a10.18,10.18,0,0,1-9.78-13l9.32-32.11a37.91,37.91,0,0,1,36.23-27.2H291.87a37.91,37.91,0,0,1,36.23,27.2l9.32,32.11a10.18,10.18,0,0,1-9.78,13ZM76.57,438.44H326.05l-8.88-30.58a26.48,26.48,0,0,0-25.3-19H110.75a26.45,26.45,0,0,0-25.29,19Z"
      />
      <path
        style={{ fill: color }}
        d="M295.91,388.87H107.53l.17-31.26a33.09,33.09,0,0,1,8.49-22.2,28.61,28.61,0,0,1,21.23-9.75H265.2a29.09,29.09,0,0,1,22,10.62A33.73,33.73,0,0,1,295,357.12ZM119,377.49H284.21l-.57-20.05a22.33,22.33,0,0,0-5.11-13.79A17.54,17.54,0,0,0,265.2,337H137.42a17.36,17.36,0,0,0-12.82,6,21.75,21.75,0,0,0-5.51,14.59Z"
      />
      <path
        style={{ fill: color }}
        d="M230.84,300.24l-75.67-45.15,66.34-111.18,75.67,45.15Zm-60.06-49.09,56.12,33.48L281.57,193l-56.12-33.48Z"
      />
      <path
        style={{ fill: color }}
        d="M297.58,199.38a19.34,19.34,0,0,1-9.91-2.74l-68.32-40.76a19.43,19.43,0,0,1-6.72-26.61l.59-1a19.43,19.43,0,0,1,26.61-6.73l68.32,40.76a19.42,19.42,0,0,1,6.72,26.62l-.59,1A19.42,19.42,0,0,1,297.58,199.38ZM229.9,130.2a8,8,0,0,0-6.9,3.91l-.6,1a8,8,0,0,0,2.78,11l68.32,40.76a8,8,0,0,0,11-2.78l.6-1a8,8,0,0,0-2.78-11L234,131.33A8,8,0,0,0,229.9,130.2Z"
      />
      <path
        style={{ fill: color }}
        d="M222.43,325.33a19.33,19.33,0,0,1-9.91-2.73L144.2,281.83a19.41,19.41,0,0,1-6.72-26.61l.59-1a19.41,19.41,0,0,1,26.61-6.72L233,288.27a19.43,19.43,0,0,1,6.72,26.61l-.59,1A19.42,19.42,0,0,1,222.43,325.33Zm-67.68-69.18a8.05,8.05,0,0,0-6.9,3.92l-.6,1a8,8,0,0,0,2.78,11l68.32,40.76a8,8,0,0,0,11-2.78l.6-1a8,8,0,0,0-2.78-11l-68.32-40.76A7.91,7.91,0,0,0,154.75,256.15Z"
      />
      <path
        style={{ fill: color }}
        d="M265.47,284.57a6.75,6.75,0,0,1-3.45-1l-25.45-15.18,36.35-60.92,25.45,15.18a6.77,6.77,0,0,1,2.34,9.26l-29.43,49.32a6.79,6.79,0,0,1-5.81,3.3Zm-13.29-20.09,11.7,7,24.68-41.37-11.7-7Z"
      />
      <path
        style={{ fill: color }}
        d="M418.11,355.89a19.61,19.61,0,0,1-10.08-2.8L265.8,268.24l20.83-34.92,142.23,84.86a19.72,19.72,0,0,1,6.84,27.06l-.61,1a19.62,19.62,0,0,1-12.11,9A19.81,19.81,0,0,1,418.11,355.89Zm-136.7-91.6,132.45,79a8.37,8.37,0,0,0,11.46-2.9l.6-1A8.35,8.35,0,0,0,423,328l-132.46-79Z"
      />
    </svg>
  );
};

export default AttorneyIcon;
